export default {
    PICA_SERVICE: 'pica_service',
    CONTRACT_MANAGER: 'contract_manager',
    GLOBAL: 'global',
}
